import React from 'react';
import { HorizontalCenteredContainer, SpinnerContainer } from './loading-spinner.styled';
import Spinner from '@atlaskit/spinner';

import UFOLoadHold from '@atlaskit/react-ufo/load-hold';

const QUICK_SEARCH_LOADING_HOLD = 'quick-search-loading';

export const LoadingSpinner = () => {
	const spinner = (
		<SpinnerContainer data-testid="search-dialog-loading-spinner">
			<HorizontalCenteredContainer>
				<Spinner />
			</HorizontalCenteredContainer>
		</SpinnerContainer>
	);

	return <UFOLoadHold name={QUICK_SEARCH_LOADING_HOLD}>{spinner}</UFOLoadHold>;
};
